export default {
  en: {
    notificationCenter: {
      justNow: "Just now",
      minutesAgo: "{{count}}m ago",
      hoursAgo: "{{count}}h ago",
      browserDesc: "Receive browser notifications",
      verifiedDesc: "When results are verified",
      submittedDesc: "When new results are submitted",
      settings: "Notification settings",
      clearAll: "Clear all notifications"
    },
    notificationInbox: {
      new: "New",
      markAsRead: "Mark as read",
      open: "Open",
      justNow: "Just now",
      minutesAgo: "{{count}}m ago",
      hoursAgo: "{{count}}h ago",
      daysAgo: "{{count}}d ago",
      loadFailed: "Failed to load notifications",
      allMarkedRead: "All notifications marked as read",
      markAllFailed: "Failed to mark all as read",
      cleared: "Cleared {{count}} old notifications",
      clearFailed: "Failed to clear old notifications",
      title: "Notifications",
      live: "Live updates enabled",
      cached: "Viewing cached notifications",
      refresh: "Refresh",
      markAllRead: "Mark All Read",
      clearOld: "Clear Old",
      all: "All",
      unread: "Unread",
      corrections: "Corrections",
      approvals: "Approvals",
      loading: "Loading notifications...",
      empty: "No notifications",
      emptyAll: "You're all caught up! New notifications will appear here.",
      emptyFilter: "No {{filter}} notifications to show.",
      filter_unread: "unread",
      filter_corrections: "corrections",
      filter_approvals: "approvals",
      stats: "Notification Statistics",
      total: "Total",
      back: "Back"
    }
  },
  fr: {
    notificationCenter: {
      justNow: "À l'instant",
      minutesAgo: "il y a {{count}} min",
      hoursAgo: "il y a {{count}} h",
      browserDesc: "Recevoir des notifications dans le navigateur",
      verifiedDesc: "Lorsque des résultats sont vérifiés",
      submittedDesc: "Lorsque de nouveaux résultats sont soumis",
      settings: "Paramètres des notifications",
      clearAll: "Effacer toutes les notifications"
    },
    notificationInbox: {
      new: "Nouveau",
      markAsRead: "Marquer comme lu",
      open: "Ouvrir",
      justNow: "À l'instant",
      minutesAgo: "il y a {{count}} min",
      hoursAgo: "il y a {{count}} h",
      daysAgo: "il y a {{count}} j",
      loadFailed: "Échec du chargement des notifications",
      allMarkedRead: "Toutes les notifications ont été marquées comme lues",
      markAllFailed: "Échec du marquage de toutes les notifications comme lues",
      cleared: "{{count}} anciennes notifications supprimées",
      clearFailed: "Échec de la suppression des anciennes notifications",
      title: "Notifications",
      live: "Mises à jour en direct activées",
      cached: "Affichage des notifications en cache",
      refresh: "Actualiser",
      markAllRead: "Tout marquer comme lu",
      clearOld: "Supprimer les anciennes",
      all: "Toutes",
      unread: "Non lues",
      corrections: "Corrections",
      approvals: "Approbations",
      loading: "Chargement des notifications...",
      empty: "Aucune notification",
      emptyAll: "Vous êtes à jour ! Les nouvelles notifications apparaîtront ici.",
      emptyFilter: "Aucune notification ({{filter}}) à afficher.",
      filter_unread: "non lues",
      filter_corrections: "corrections",
      filter_approvals: "approbations",
      stats: "Statistiques des notifications",
      total: "Total",
      back: "Retour"
    }
  }
};
